
import UserProfile from '../components/user-profile.vue';
import Signup from '../signup/signup.vue';
import SignupEmployee from '../signup_employee/signup_employee.vue';
import EmployeeProfile from './employee-profile.vue';
import ManagerAccessConfig from './manager-access-config.vue';
import UnitAttStats from './unit-att-stats.vue';
import EmployeeAccessConfig from './employee-access-config.vue';
import Stars from './stars.vue';

export default {
    name: 'pl_cleaner',
    components: {
        UserProfile,
        Signup,
        SignupEmployee,
        EmployeeProfile,
        UnitAttStats,
        ManagerAccessConfig,
        EmployeeAccessConfig,
        Stars
    },
    async created() {

        let t = this;

        t.dict.wgGroup = listToDict(t.list.wgGroup);

        await t.loadData();

        t.employee = t.U;

        t.ready = true;

    },
    activated() {
        let t = this;
    },
    methods: {

        async loadData() {

            let t = this;

            if (t.$route.name == 'pl_employee') {
                t.roles = [1, 4];
            }
            else {
                t.roles = [2];
            }

            await axios.get('org?_with=owner').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.units = [];
                    });
                    t.list.org = arr;
                    t.dict.org = listToDict(t.list.org);
                }
            });

            await axios.get('unit').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;

                    arr.forEach(item => {
                        item.employees = [];
                        item.managers = [];
                        item.managerIdArr = [];
                        if (item.manager_ids) {
                            item.managerIdArr = item.manager_ids.split(',');
                        }
                        if (t.dict.org[item.org_id]) {
                            t.dict.org[item.org_id].units.push(item);
                        }
                    });

                    // let arr2 = [{ 'id': 0, 'name': '無所属', 'employees': [] }];
                    //t.list.unit = arr2.append(arr);

                    t.list.unit = arr;

                    t.dict.unit = listToDict(t.list.unit);
                }
            });

            await axios.get('workGroup').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;

                    t.list.wgGroup.forEach(item => {
                        item.items = [];
                    });

                    arr.forEach(item => {
                        item.employees = [];
                        item._name = item.name;
                        item.editing = false;
                    });

                    t.list.workGroup = arr;
                    t.dict.workGroup = listToDict(t.list.workGroup);

                    t.list.workGroup.forEach(item => {
                        let wgGroup = t.dict.wgGroup[item.group_id];
                        if (wgGroup) {
                            wgGroup.items.push(item);
                        }
                    });

                    t.list.wgGroup.forEach(item => {
                        item.activeWorkGroup = item.items[0];
                    });
                }
            });

            await axios.get('employee?role=' + t.roles.join(',') + '&_with=config,grant').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.selected = false;
                        item.showPopover = false;
                        if (item.config) {
                            let unit = t.dict.unit[item.config.unit_id];
                            if (unit) {
                                if (unit.managerIdArr.includes(item.id.toString())) {
                                    unit.managers.push(item);
                                }
                                else {
                                    unit.employees.push(item);
                                }
                            }
                            // else {
                            //     this.list.unit[0].employees.push(item);
                            // }

                            let workGroup = t.dict.workGroup[item.config.wg_id];

                            if (workGroup) {
                                workGroup.employees.push(item);
                            }
                        }
                    })
                    // if (this.list.unit[0].employees.length == 0) {
                    //     this.list.unit.remove(this.list.unit[0]);
                    // }
                    t.list.employee = arr;
                }
            });

            t.selectOrg(t.list.org[0]);
            // t.showMember(t.list.employee[0]);
        },

        showMember(item, unit) {

            let t = this;

            t.employee = item;
            t.unit = unit;

            t.pop.employeeProfile = true;
        },

        selectOrg(item) {
            let t = this;
            t.org = item;
        },

        afterSignUp() {
            this.pop.signUp = false;
            this.loadData();
        },

        signUp(unit) {

            let t = this;

            t.signUpUnitId = null;

            if (unit) {
                t.signUpUnitId = unit.id;
            }

            t.pop.signUp = true;

        },

        signUp2() {

            let t = this;

            t.pop.signUp = true;

        },

        closePopup() {
            let t = this;

            for (const key in t.pop) {
                if (t.pop[key])
                    t.pop[key] = false;
            }
        },

        closeCropper() {
            $('.cropper-item').hide();
        },

        confirmCropper() {

        },

        uploadPicture(blobName) {

            let t = this;

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImg');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 1,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('.cropper-item').show();
                }

                event.target['value'] = '';


            };

            t.confirmCropper = () => {
                t.cropper.getCroppedCanvas({
                    minHeight: 600,
                    minWdith: 600,
                    maxHeight: 1000,
                    maxWdith: 1000,
                    fillColor: '#fff',
                }).toBlob((blob) => {
                    t.imgBlob[blobName] = {
                        blob: blob,
                        url: getObjectURL(blob),
                    };
                    t.closeCropper();
                });
            }

            ImageUploader.openSelector();
        },

        addOrg() {
            let t = this;
            t.f.org = {
                name: '',
                desc: '',
                img_url: ''
            };
            t.pop.addOrg = true;
        },

        async saveOrg() {

            let t = this;

            let f = t.f.org;

            // if (!t.imgBlob.org && !f.img_url) {
            //     A.err('企業画像は必須です');
            //     return;
            // }

            if (!f.name) {
                A.err('企業名は必須です');
                return;
            }

            if (!f.desc) {
                A.err('企業説明は必須です');
                return;
            }

            if (t.busying)
                return;

            t.busying = true;

            if (t.imgBlob.org) {
                let fd = new FormData();
                fd.append('image', t.imgBlob.org.blob);
                await axios.post('org/saveImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                    if (res.data.status == 1) {
                        f.img_url = res.data.options.img_url;
                    }
                });

            }

            let res;
            if (t.pop.editOrg) {
                res = await axios.put('org/' + t.org.id, f);
            }
            else {
                res = await axios.post('org', f);
            }

            t.busying = false;

            if (res.data.status == 1) {
                A.toast('企業を作成しました');
                t.pop.addOrg = false;
                t.pop.editOrg = false;

                t.f.org = {
                    name: '',
                    desc: '',
                    img_url: ''
                };
                t.imgBlob.org = null;
                t.loadData();
            }

        },

        selectMember(employee) {
            let t = this;

            t.list.employee.forEach(item => {
                if (item.id != employee.id) {
                    item.selected = false;
                }
            });
        },

        editOrg(item) {
            let t = this;
            t.org = item;
            copyFrom(t.f.org, t.org);
            t.pop.editOrg = true;
        },

        editOwner() {
            let t = this;

            t.pop.changeOwner = true;

            t.list.employee.forEach(item => {
                if (item.id == t.org.owner.id) {
                    item.selected = true;
                }
            });
        },

        confirmChangeOwner() {

            let t = this;

            let owner = t.list.employee.filter(item => item.selected)[0];

            if (!owner) {
                A.err('代表者を選択してください');
                return;
            }


            if (t.busying)
                return;

            t.busying = true;

            axios.put('org/' + t.org.id, { owner_id: owner.id }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    t.org.owner = owner;
                    t.pop.changeOwner = false;
                    t.pop.changeOwnerAlert = true;
                }
            });

        },

        addUnit() {
            let t = this;
            t.f.unit = {
                name: '',
                desc: '',
                img_url: ''
            };
            t.pop.addUnit = true;
        },

        async saveUnit() {

            let t = this;

            let f = t.f.unit;

            // if (!t.imgBlob.unit && !f.img_url) {
            //     A.err('部署画像は必須です');
            //     return;
            // }

            if (!f.name) {
                A.err('部署名は必須です');
                return;
            }

            if (!f.desc) {
                A.err('部署説明は必須です');
                return;
            }

            if (t.busying)
                return;

            t.busying = true;

            if (t.imgBlob.unit) {
                let fd = new FormData();
                fd.append('image', t.imgBlob.unit.blob);
                await axios.post('unit/saveImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                    if (res.data.status == 1) {
                        f.img_url = res.data.options.img_url;
                    }
                });

            }

            let res;
            if (t.pop.editUnit) {
                res = await axios.put('unit/' + t.unit.id, f);
            }
            else {
                res = await axios.post('unit', f);
            }

            t.busying = false;

            if (res.data.status == 1) {
                A.toast('部署を作成しました');
                t.pop.addUnit = false;
                t.pop.editUnit = false;

                t.f.unit = {
                    name: '',
                    desc: '',
                    img_url: ''
                };
                t.imgBlob.unit = null;
                t.loadData();
            }

        },

        editUnit(item) {
            let t = this;
            t.unit = item;
            copyFrom(t.f.unit, t.unit);
            t.pop.editUnit = true;
        },

        changeManager() {
            let t = this;
            t.pop.editMembers = false;
            t.pop.removeUnit = false;
            t.pop.changeManager = true;

            t.unit.managers.forEach(item => {
                item.selected = true;
            });
            t.unit.employees.forEach(item => {
                item.selected = false;
            });
        },

        saveManagers() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let ids = [];

            let all = [].concat(t.unit.employees.filter(item => item.selected), t.unit.managers.filter(item => item.selected));

            all.forEach(item => {
                ids.push(item.id);
            });

            axios.put('unit/' + t.unit.id, { 'manager_ids': ids.join(',') }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    let arr = [].concat(t.unit.employees, t.unit.managers);

                    t.unit.managers = [];
                    t.unit.employees = [];
                    arr.forEach(item => {
                        if (ids.indexOf(item.id) > -1) {
                            t.unit.managers.push(item);
                        }
                        else {
                            t.unit.employees.push(item);
                        }
                    });

                    A.toast('Saved.');
                    t.pop.changeManager = false;
                }
            });

        },

        editMembers() {
            let t = this;
            t.pop.changeManager = false;
            t.pop.removeUnit = false;
            t.pop.editMembers = true;

            t.list.employee.forEach(item => {
                item.selected = false;
            });

            t.unit.managers.forEach(item => {
                item.selected = true;
            });
            t.unit.employees.forEach(item => {
                item.selected = true;
            });
            t.nounitEmployees.forEach(item => {
                item.selected = false;
            });
            t.noorgEmployees.forEach(item => {
                item.selected = false;
            });
        },

        saveEmployees() {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let arr = [];

            arr = arr.concat(t.unit.employees.filter(item => !item.selected));
            arr = arr.concat(t.unit.managers.filter(item => !item.selected));

            arr.forEach(item => {
                t.unit.employees.remove(item);
                t.unit.managers.remove(item);
            });

            let arrToRemove = arr;

            arr = [];
            arr = arr.concat(t.nounitEmployees.filter(item => item.selected));
            arr = arr.concat(t.noorgEmployees.filter(item => item.selected));

            let arrToAdd = arr;

            axios.post('employeeConfig/batchSave', {
                add: arrToAdd.map(item => item.id).join(','),
                remove: arrToRemove.map(item => item.id).join(','),
                unit_id: t.unit.id
            }).then(res => {
                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.pop.editMembers = false;
                    arrToRemove.forEach(item => {
                        t.unit.employees.remove(item);
                        item.config.unit_id = null;
                    });
                    arrToAdd.forEach(item => {
                        item.config.unit_id = t.unit.id;
                        item.config.org_id = t.org.id;
                        t.unit.employees.push(item);
                    });
                }
            });
        },

        removeUnit() {
            let t = this;
            t.pop.changeManager = false;
            t.pop.editMembers = false;
            t.pop.removeUnit = true;
        },

        confirmRemoveUnit() {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.delete('unit/' + t.unit.id).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    t.unit.managers.forEach(item => {
                        item.config.unit_id = null;
                    });
                    t.unit.employees.forEach(item => {
                        item.config.unit_id = null;
                    });
                    t.list.unit.remove(t.unit);
                    t.unit = null;
                    A.toast('Saved.');
                }

            });

        },

        removeMember(item, isMgr, unit) {
            let t = this;

            t.confirmRemoveMember = () => {

                if (t.busying)
                    return;

                t.busying = true;

                axios.put('employeeConfig/' + item.config.id, { unit_id: null }).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        if (isMgr) {
                            unit.managers.remove(item);
                        }
                        else {
                            unit.employees.remove(item);
                        }
                        t.pop.removeMember = false;
                        item.config.unit_id = null;

                    }
                });

            }

            t.pop.removeMember = true;
        },

        removeAccount(item) {
            let t = this;

            t.confirmRemoveAccount = () => {

                if (t.busying)
                    return;

                t.busying = true;

                axios.post('employee/deleteAccount/' + item.id).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        t.list.employee.remove(item);
                        t.pop.removeAccount = false;
                    }
                });

            }

            t.pop.removeAccount = true;
        },

        showAccessGrant(type) {

            let t = this;

            t.pop.editUnit = false;

            if (type == 1) {
                t.pop.accessGrant_manager = true;
            }
            else if (type == 2) {
                t.pop.accessGrant_employee = true;
            }
        },


        editMembers2(workGroup) {
            let t = this;

            t.workGroup = workGroup;

            t.list.employee.forEach(item => {
                item.selected = false;
            });

            t.workGroupMembers(workGroup).forEach(item => {
                item.selected = true;
            });

            t.pop.editMembers2 = true;
        },

        saveEmployees2(workGroup) {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let arrToRemove = t.workGroupMembers(workGroup).filter(item => !item.selected && item.config.wg_id == workGroup.id);

            let arrToAdd = t.list.employee.filter(item => item.selected && !item.config.wg_id);

            axios.post('employee/batchSaveWorkGroup', {
                add: arrToAdd.map(item => item.id).join(','),
                remove: arrToRemove.map(item => item.id).join(','),
                wg_id: workGroup.id
            }).then(res => {
                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.pop.editMembers2 = false;
                    arrToRemove.forEach(item => {
                        let workGroup = t.dict.workGroup[item.config.wg_id];
                        if (workGroup) {
                            workGroup.employees.remove(item);
                        }
                        item.config.wg_id = null;
                    });
                    arrToAdd.forEach(item => {
                        item.config.wg_id = workGroup.id;
                        workGroup.employees.push(item);
                    });
                }
            });
        },

        removeMemberFromWorkGroup(item, workGroup) {
            let t = this;

            t.confirmremoveMemberFromWorkGroup = () => {

                if (t.busying)
                    return;

                t.busying = true;

                axios.put('employeeConfig/' + item.config.id, { wg_id: null }).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        t.pop.removeMemberFromWorkGroup = false;
                        workGroup.employees.remove(item);
                        item.config.wg_id = null;
                    }
                });

            }

            t.pop.removeMemberFromWorkGroup = true;
        },

        addWorkGroup(wgGroup) {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.post('workGroup', { 'name': 'グループ名', 'group_id': wgGroup.id }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    let item = res.data.options;
                    item.employees = [];
                    item._name = item.name;
                    item.editing = false;
                    wgGroup.items.unshift(item);
                    wgGroup.activeWorkGroup = item;
                    t.list.workGroup.unshift(item);
                    t.dict.workGroup[item.id] = item;
                }
            });

        },
        removeWorkGroup(item, wgGroup) {
            let t = this;
            t.confirmRemoveWorkGroup = () => {
                axios.delete('workGroup/' + item.id).then(res => {
                    if (res.data.status == 1) {
                        t.pop.removeWorkGroup = false;

                        item.employees.forEach(employee => {
                            employee.config.wg_id = null;
                        });

                        t.list.workGroup.remove(item);
                        t.dict.workGroup = listToDict(t.list.workGroup);

                        if (wgGroup) {
                            wgGroup.items.remove(item);

                            if (wgGroup.activeWorkGroup == item)
                                wgGroup.activeWorkGroup = wgGroup.items[0] || null;
                        }

                    }
                });

            }
            t.pop.removeWorkGroup = true;
        },
        saveWorkGroup(item) {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.put('workGroup/' + item.id, { name: item._name }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    item.name = item._name;
                    item.editing = false;
                }
            });
        },

        noworkgroupEmployees2(workGroup) {
            let t = this;
            return t.list.employee.filter(item => {
                if (!item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        return (!item.config.wg_id) || item.config.wg_id == workGroup.id;
                    }
                }
                return false;
            });
        },
        workGroupMembers(workGroup) {
            let t = this;
            return t.list.employee.filter(item => {
                return item.config.wg_id == workGroup.id;
            });
        },
    },
    data() {
        return {
            ready: false,

            f: {
                org: {
                    name: '',
                    desc: '',
                    img_url: ''
                },
                unit: {
                    name: '',
                    desc: '',
                    img_url: ''
                }
            },
            imgBlob: {
                org: null,
                unit: null,
            },
            unit: null,
            showSignUp: false,
            org: null,
            employee: null,
            unit: null,
            workGroup: null,
            signUpUnitId: null,
            pop: {
                accessGrant_manager: false,
                accessGrant_employee: false,

                signUp: false,

                unitAttStats: false,
                employeeProfile: false,

                addOrg: false,
                editOrg: false,

                addUnit: false,
                editUnit: false,

                changeOwner: false,
                removeMember: false,
                removeAccount: false,
                changeOwnerAlert: false,

                removeUnit: false,
                changeManager: false,
                editMembers: false,

                removeMemberFromWorkGroup: false,
                editMembers2: false,

                removeWorkGroup: false,
            },
            list: {
                employee: [],
                unit: [],
                org: [],
                workGroup: [],
                wgGroup: [
                    { id: 1, items: [], activeWorkGroup: null },
                    { id: 2, items: [], activeWorkGroup: null },
                    { id: 3, items: [], activeWorkGroup: null },
                ]
            },
            dict: {
                org: {},
                unit: {},
                workGroup: {},
                wgGroup: {},
            },
            selectedTask: null,
            currentItem: null,
            showTaskPopover: false,
            showCleanTaskEditor: false,

            roles: [],
            search: {
                keywords: ''
            }
        };
    },
    computed: {
        filteredworkGroupMembers() {
            let t = this;
            return t.list.employee.filter(item => {
                if (item.config.wg_id == t.workGroup.id || item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        return true;
                    }
                }
                return false;
            });
        },

        noworkgroupEmployees() {
            let t = this;
            return t.list.employee.filter(item => {
                return !item.config.wg_id;
            });
        },

        orgEmployees() {

            let t = this;
            let arr = [];

            t.list.employee.forEach(item => {
                if (item.config.org_id == t.org.id) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },
        nounitEmployees() {
            let t = this;
            return t.list.employee.filter(item => {
                return !item.config.unit_id && item.config.org_id;
            });
        },
        noorgEmployees() {
            let t = this;
            return t.list.employee.filter(item => {
                return !item.config.org_id;
            });
        },
        nounitEmployees_unselect() {
            let t = this;
            let arr = [];

            t.nounitEmployees.forEach(item => {
                if (!item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            return arr;

        },
        noorgEmployees_unselected() {
            let t = this;
            let arr = [];

            t.noorgEmployees.forEach(item => {
                if (!item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },
        unitManagers() {
            let t = this;
            let arr = [];

            t.unit.employees.forEach(item => {
                if (item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            t.unit.managers.forEach(item => {
                if (item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },
        unitEmployees() {
            let t = this;
            let arr = [];

            t.unit.managers.forEach(item => {
                if (!item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            t.unit.employees.forEach(item => {
                if (!item.selected) {
                    if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },
        unitAllEmployees() {
            let t = this;
            let arr = [];

            t.unit.managers.forEach(item => {
                if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                    arr.push(item);
                }
            });

            t.unit.employees.forEach(item => {
                if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                    arr.push(item);
                }
            });

            t.nounitEmployees.filter(item => item.selected).forEach(item => {
                if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                    arr.push(item);
                }
            });

            t.noorgEmployees.filter(item => item.selected).forEach(item => {
                if (!t.search.keywords || item.name.indexOf(t.search.keywords) > -1) {
                    arr.push(item);
                }
            });

            return arr;
        }
    }
};
